export const MODEL_PRELOAD_DEBOUNCE = 150;
export const PRELOAD_AEM_MODEL_EVENT = 'preload-aem-path';
export const PRELOAD_HYPERDRIVE_MODEL_EVENT = 'preload-hyperdrive-path';
